export default __webpack_public_path__ + "static/media/Platform_Banner.85f44a85.jpg";